import ApiService from './api.service'
import qs from 'qs'

const ImoveisService = {

	getStatus: (idImovel) => ApiService.get('status/imovel', idImovel),

	getImoveis: (filtro, page) => ApiService.query('lista/imovel/' + filtro, { params: { pagina: page } }),

	countImoveis: (filtro) => ApiService.query('lista/imovel/' + filtro + '/count'),

	getImovel: (idImovel) => ApiService.get('dados/imovel', idImovel),

	getAreasARegularizar: (idImovel) => ApiService.get('dados/areasARegularizar', idImovel),

	getPdf: (idImovel, imgMapa) => ApiService.post(`dados/imovel/${idImovel}/pdf`, qs.stringify({ imgMapa }))

}

export default ImoveisService



// WEBPACK FOOTER //
// ./src/utils/services/imoveis.service.js